<template>
  <div class="aside-container">
    <!-- CBT按钮 -->
    <div
      class="aside-item cbt-btn"
      @click="
        jumpLink(
          'https://gwww.gnjoy.hk/sea_official/index.html',
          '下载游戏按钮',
          '侧边栏'
        )
      "
    >
      <div class="cbt-btn__role" aria-hidden="true"></div>
      <div class="cbt-btn__label">
        <span
          class="cbt-btn__text"
          :class="reserveBtnTextSizeClass"
        >{{ reserveBtnText }}</span>
      </div>
    </div>

    <!-- 音乐控制按钮 -->
    <div class="aside-item music-btn" @click="switchMusic">
      <div class="music-icon" :class="{ active: musicState }"></div>
    </div>

    <!-- YouTube按钮 -->
    <div
      class="aside-item youtube-btn"
      @click="
        jumpLink(
          'https://www.youtube.com/@RagnarokTheNewWorld',
          'YouTube按钮',
          '侧边栏'
        )
      "
    >
      <div class="hot-icon"></div>
    </div>

    <!-- Discord按钮 -->
    <div
      class="aside-item discord-btn"
      @click="
        jumpLink('https://discord.gg/pGbjenEwgN', 'Discord按钮', '侧边栏')
      "
    >
      <div class="hot-icon"></div>
    </div>

    <!-- Facebook按钮 -->
    <div
      class="aside-item facebook-btn"
      @click="
        jumpLink(
          'https://www.facebook.com/RagnarokTheNewWorld.Gravity',
          'FB按钮',
          '侧边栏'
        )
      "
    ></div>

    <!-- TikTok按钮 -->
    <div
      class="aside-item tiktok-btn"
      @click="
        jumpLink(
          'https://www.tiktok.com/@ragnarok.the.new.world?_r=1&_t=ZS-95UccDzy4LU',
          'TikTok按钮',
          '侧边栏'
        )
      "
    ></div>

    <!-- Instagram按钮 -->
    <div
      class="aside-item instagram-btn"
      @click="
        jumpLink(
          'https://www.instagram.com/ro_neworldsea/',
          'Instagram按钮',
          '侧边栏'
        )
      "
    ></div>

    <!-- 回到顶部按钮 -->
    <div class="aside-item back-top-btn" @click="scrollToTop"></div>

    <!-- Activity按钮 -->
    <!-- <div class="aside-item activity-btn" @click="handleActivityClick"></div> -->
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import LanguageHook from "@hooks/language";

const { getLangTxt } = LanguageHook();

const reserveBtnText = computed(() =>
  getLangTxt("reserveBtnText", "【点我\n预约】")
);

const reserveBtnTextSizeClass = computed(() => {
  const plainText = reserveBtnText.value
    .replace(/\n/g, "")
    .replace(/[【】]/g, "");
  const length = plainText.length;

  if (length > 14) return "size-xs";
  if (length > 10) return "size-sm";
  if (length > 6) return "size-md";
  return "size-default";
});

// 定义emit事件
const emit = defineEmits(["show-popup"]);

// 音乐状态和音频元素
const musicState = ref(false);
const audioElement = ref(null);

// 初始化音频
onMounted(async () => {
  try {
    // 使用 assets 目录中的音频文件
    audioElement.value = new Audio(
      new URL("../assets/media/bgm.mp3", import.meta.url).href
    );
    audioElement.value.loop = true; // 循环播放
    audioElement.value.preload = "auto"; // 预加载音频
  } catch (error) {
    console.error("音频初始化失败:", error);
  }
});

// 组件卸载时清理音频
onUnmounted(() => {
  if (audioElement.value) {
    audioElement.value.pause();
    audioElement.value = null;
  }
});

// 切换音乐播放状态
const switchMusic = () => {
  if (!audioElement.value) {
    console.warn("音频元素未初始化");
    return;
  }

  musicState.value = !musicState.value;

  if (musicState.value) {
    // 尝试播放音频
    audioElement.value.play().catch((err) => {
      console.error("播放音频失败:", err);
      // 播放失败时重置状态
      musicState.value = false;

      // 根据错误类型给出不同提示
      if (err.name === "NotAllowedError") {
        console.log("浏览器阻止自动播放，需要用户交互后才能播放");
      } else if (err.name === "NotSupportedError") {
        console.log("浏览器不支持该音频格式");
      }
    });
  } else {
    audioElement.value.pause();
  }
};

// 滚动到顶部
const scrollToTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
};

// 跳转链接
const jumpLink = (url, buttonName, pageName) => {
  window.open(window.globalGetGotoLink({ link: url }), "_blank");
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: buttonName,
    eventReason: pageName,
    aid: window.activity_name,
    gameId: window.game_id,
  });
};

// 处理Activity按钮点击
const handleActivityClick = () => {
  emit("show-popup", "rulePopup", "活动规则");
};
</script>
